const START_FORMAT: Intl.DateTimeFormatOptions = {
  weekday: 'short',
  day: 'numeric',
  month: 'short',
  minute: '2-digit',
  timeZoneName: 'short',
}

type FormatOptions = {
  /** The viewer's locale by default. */
  locale?: string
  /** The viewer's time zone by default. */
  timeZone?: string
  /** For deciding whether to show the year. */
  now?: Date
}

function yearIn(date: Date, timeZone?: string) {
  return new Intl.DateTimeFormat('en', { year: 'numeric', timeZone }).format(date)
}

/** 05:30 on a 24-hour clock, 5:30 AM on a 12-hour one: a numeric hour alone gives 0:18 on a 24-hour clock. */
function hourFor(locale?: string) {
  return new Intl.DateTimeFormat(locale, { hour: 'numeric' }).resolvedOptions().hour12 ? 'numeric' : '2-digit'
}

/**
 * When an event starts, as its card on /explore, its details and its invitations say it: weekday, date and time in the
 * viewer's own time zone with that zone's short name, so 18:00 in Cape Town reads 08:00 PST in Los Angeles. The name is
 * an abbreviation where the viewer's locale has one (CEST) and an offset where it doesn't (GMT+2). The year shows only
 * when it isn't this year.
 */
export function formatEventStart(startsAt: string, { locale, timeZone, now = new Date() }: FormatOptions = {}): string {
  const date = new Date(startsAt)
  if (Number.isNaN(date.getTime())) return ''
  const year = yearIn(date, timeZone) === yearIn(now, timeZone) ? {} : { year: 'numeric' as const }
  return new Intl.DateTimeFormat(locale, { ...START_FORMAT, hour: hourFor(locale), ...year, timeZone }).format(date)
}
